export default __webpack_public_path__ + "static/media/ReSource.fc1b6fdb.jpeg";